import React, { useEffect, useState } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Table from 'src/components/commons/Table/Table';
import { Main } from 'src/components/commons/Main';
import { getFounderVendorMatchesAdmin } from 'src/api/matches';
import StatusChip from 'src/components/commons/StatusChip';
import { formatPhone, renderSafeValue } from 'src/helpers';

const columns = [
  { header: 'Offered Service', accessor: 'offered_service', align: 'left', render: (_, row) => renderSafeValue(row.offered_service, 'offered_service') },
  { header: 'Call Status', accessor: 'status', align: 'center', render: (value) => <StatusChip status={value} /> },
  { header: 'Founder Name', accessor: 'founder_name', align: 'center' },
  { header: 'Founder Email', accessor: 'founder_email', align: 'center' },
  { header: 'Founder Business Phone', accessor: 'founder_business_phone', align: 'center', render: formatPhone },
  { header: 'Founder Personal Phone', accessor: 'founder_personal_phone', align: 'center', render: formatPhone },
  { header: 'Vendor Name', accessor: 'vendor_name', align: 'center' },
  { header: 'Vendor Email', accessor: 'vendor_email', align: 'center' },
  { header: 'Vendor Business Phone', accessor: 'vendor_business_phone', align: 'center', render: formatPhone },
  { header: 'Vendor Personal Phone', accessor: 'vendor_personal_phone', align: 'center', render: formatPhone },
];

export default function AdminMatches() {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    async function fetchMatches() {
      setLoading(true);
      setError(false);
      try {
        const matchesArr = await getFounderVendorMatchesAdmin({ page: page + 1, limit: rowsPerPage });
        setMatches(matchesArr || []);
        setTotalCount((matchesArr && matchesArr.length > 0 && matchesArr[0].total_count) || 0);
        console.log(matchesArr);
      } catch (e) {
        setError(true);
      } finally {
        setLoading(false);
      }
    }
    fetchMatches();
  }, [page, rowsPerPage]);

  return (
    <Main>
      <Box display={'flex'} justifyContent='space-between' p={4} borderBottom={'1px solid rgb(239 232 251)'}>
        <Typography component={'h2'} variant='h6'>
          Matches
        </Typography>
      </Box>
      <Box p={4}>
        <Table
          columns={columns}
          data={matches}
          loading={loading}
          error={error}
          page={page}
          rowsPerPage={rowsPerPage}
          totalCount={totalCount}
          onPageChange={(_, newPage) => setPage(newPage)}
          onRowsPerPageChange={e => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
          stickyHeader
          className='border-0'
          emptyStateMessage='No matches found.'
        />
      </Box>
    </Main>
  );
} 